import { playSound, Sound } from '~/assets/sounds';
import { Dot } from '../Dot';
import { StyledContainer } from './ChatCategory.styled';

interface IChatCategoryProps extends React.HTMLAttributes<HTMLDivElement> {
	name: string;
	title: string;
	active: boolean;
	hasUnreadMessages: boolean;
	changeActiveChannelHandler: (id: string) => void;
}

const ChatCategory: React.FC<IChatCategoryProps> = ({
	name,
	title,
	active,
	hasUnreadMessages,
	changeActiveChannelHandler,
}: IChatCategoryProps) => {
	return (
		<StyledContainer
			$active={active}
			onClick={() => {
				changeActiveChannelHandler(name);
				playSound(Sound.ClickButton);
			}}
			onMouseEnter={() => playSound(Sound.LinkCursor)}
		>
			<p style={{ textTransform: 'uppercase' }}>{title}</p>
			{hasUnreadMessages ? <Dot $color={'#EB1818'} /> : <></>}
		</StyledContainer>
	);
};

export { ChatCategory };
